import React from "react";

const Walk = () => (
  <svg
    version="1.1"
    id="bus_circle"
    x="0px"
    y="0px"
    viewBox="0 0 390 390"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M209,0c17.8,0,32.3,14.5,32.3,32.3S226.8,64.6,209,64.6s-32.3-14.5-32.3-32.3S191.2,0,209,0z M307.5,201.8
		c-4.5,6.6-13.5,8.3-20.1,3.8l0,0c0,0-44.7-30.5-47.9-32.7c-3.2-2.2-5.1-6.8-6.5-9.8c-1-2-6-11.8-9.3-18.3l-4,17l-10.4,47.1
		c0,0,55.7,65.6,56.8,66.9c1.6,1.8,2.5,5.5,3.2,8.3c0.7,2.7,14.9,79.9,14.9,79.9c2.2,11.9-5.7,23.4-17.6,25.7
		c-11.9,2.2-23.4-5.7-25.7-17.6l-14.2-76.3l-46.3-50.6c0,0-10.3,48.1-10.5,49.1s-0.7,2.5-1.3,3.9c-0.6,1.3-47.6,81.1-47.6,81.1
		c-6.2,10.4-19.7,13.9-30.2,7.7c-10.4-6.2-13.9-19.7-7.7-30.2l41.8-70.3l33.6-152.1l-22.6,18l-12.5,55.1l0,0
		c0,7.8-8.8,12.9-16.6,11.2c-7.8-1.7-12.4-4.9-10.6-17.1h0.2c0,0,13-61.2,14-63.9c0.9-2.7,2.3-5.7,3.7-6.8
		c9.4-7.6,45.8-37.4,56.5-46c12.3-10,17.7-13.7,28.2-13.7c7.9,0,16.5,2.4,25.6,11.8c4,4.1,6.9,10.8,8.9,15
		c2,4.1,27.1,53.7,27.1,53.7l43.3,30l0,0C310.3,186.2,312,195.2,307.5,201.8z"
      />
    </g>
  </svg>
);

export default Walk;
